import { Table } from "antd";
import { mockData } from "./mock";
import "./cfo.scss";
import classNames from "classnames";

const months = ["1 Jan", "2 Jan", "3 Jan", "4 Jan", "5 Jan", "6 Jan"];

const generateColumns = () => {
  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    ...months.map((month) => ({
      title: month,
      dataIndex: month,
      key: month,
      render: (text: string, record: any) => (
        <span style={{ color: record.isRed ? "#FF5C5C" : "#fff" }}>{text}</span>
      ),
    })),
  ];
  return columns;
};

const flattenData = (data: any[]) => {
  return data.map((item) => {
    const row = {
      key: item.key,
      type: item.type,
      isRed: item.isRed,
      parent: parent,
      ...(item.months || {}),
    };
    if (item.children) {
      row["children"] = flattenData(item.children);
    }
    return row;
  });
};

const CFO = () => {
  return (
    <div className="cfoWrapper">
      <Table
        columns={generateColumns()}
        dataSource={flattenData(mockData)}
        pagination={false}
        expandable={{
          expandRowByClick: true,
          expandIcon: ({ expanded, onExpand, record }) => {
            if (!record.children) {
              return null;
            }
            return (
              <button
                type="button"
                className={classNames("ant-table-row-expand-icon", {
                  "ant-table-row-expand-icon-collapsed": !expanded,
                  "ant-table-row-expand-icon-expanded": expanded,
                })}
                aria-label="Expand row"
                aria-expanded="false"
                onClick={(e) => onExpand(record, e)}
              ></button>
            );
          },
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default CFO;
